import React ,  { useState , useEffect } from 'react'
import DoCaseCard001 from './DoCaseCard001'

import axios from 'axios'

import { ApiCallGet } from '../ApiCall/ApiCall'


var arr = [

]


function DoCase001( { setSelected  , theCards , code="" , theCode , clean  }) { // Se pasa el objeto seleccionado

const [cards,setCards] = useState( [])
const [lastCode,setLastCode] = useState( "" ) ;

useEffect(() => {

    if ( clean === true )
    {
        setCards( [] ) ;
    }

} , [clean])

useEffect(() => {


    console.log( "LoadSecond") ;

    loadSecond() ;

},[code])

useEffect(() => {

} , [code])

function loadSecond()
{
    // getSecondLength/?code=" + code + "&len=1" ) // "getSecond/?code="+ code 


    code = code.replace( "-" , "")

    if ( code === "err ")
    {

        setCards( [])
        return ;
    }

    console.log( "DoCase001 code = " + code )


    ApiCallGet( "getSecondLength/?code=" + code + "&len=2"  )
    .then((response) => {

            console.log( "DoCase001 date = " + JSON.stringify( response )) ;

            arr = []
    
            for( var i = 0 ; i < response.length ; i++ )
            {
                var obj = {} ;
                obj.id = response[i].idsecond  ; // idcasesatcodigo // idcasesatcodigo
                obj.field1 = response[i].parent ;
                obj.field3 = response[i].second ;  
                obj.field2 = "Marketing Director" ;
                obj.field4 = response[i].name ;
                obj.field5 = "Creado por Charly" ;
                obj.field6 = response[i].comment ;   
                obj.idcatcasegroup = response[i].comment ;
                obj.naturaleza =  response[i].naturaleza ;
                obj.tipo =  response[i].tipo ;
            
    
                arr.push( obj ) ;
        
            }
    
            setCards( arr ) ;
   
        } ) 
        .catch( ( err ) => {
    
            console.log( "Tenemos un error")
            console.log( err ) ;
        })


}


useEffect(()  => {

    console.log( "lastCode *** = " + lastCode )

} , [lastCode])


    function theSelected( index )
    {
        console.log( "Se selecciono el index(1) = " + index + " data = " + arr[index].field3) ;

        setSelected( arr[index] )


        //axios.get(  "http://localhost:3004/livefactura/getGrupo/?code=" + arr[index].field1 )
        axios.get(  "http://localhost:3004/livefactura/getSecondLength/?code=" + cards[index].field3 + "&len=3")
        .then((response) => {
            console.log( "response(1-----------) = " +  JSON.stringify( response.data  )  ) ;



            if ( response.data.length === 0 )
            {
                theCode( "err") ;
                return ;
            }


            console.log( "casegroup  = " + JSON.stringify( response.data[0].second ) ) ;


            if ( response.data.length > 0 )
            {
                //setShowDrop( true ) ;
    
                var arr = [] ;
    
                for( var i = 0 ; i < response.data.length ; i++)
                {
                    console.log( "Codigo = " + response.data[i].second ) ;

                    var obj = {} ;
                    obj.id = response.data[i].second  ; // idcasesatcodigo // idcasesatcodigo
                    obj.field1 = response.data[i].parent ;
                    obj.field3 = response.data[i].second ;  
                    obj.field2 = "Marketing Director" ;
                    obj.field4 = "Hola" ; // response.data[i].comentario ;
                    obj.field5 = "Creado por Charly" ;
                    obj.field6 = "2024-02-11 17:01:02" ;   
                    obj.naturaleza =  response.data[i].naturaleza ;
                    
                    
                    arr.push( obj ) ;
    
                }
    

                theCards( arr ) ;


                console.log( "DoCase001 theCode = " + cards[index].field3 )



                var myCode = cards[index].field3 ;
    

                console.log( "code = " + cards[index].field3 )
        
                if ( cards[index].field3 === ( lastCode.replace( "-" , " ") ) )
                {
                    if ( lastCode.indexOf('-') >=0 )
                    {
                        myCode = cards[index].field3 ;
        
                    }
                    else{
        
                        myCode = '-' + myCode ;
        
        
                    }
                }
        
        
                console.log( "Cambiando codigo(2) " + myCode )
                setLastCode( myCode ) ;
        




                theCode( myCode ) ; //cards[index].field3
    







                //theCode( cards[index].field3 )
    
            }
            else{
                //setShowDrop ( false ) ;
            }
    


        })
        .catch( (err) => {
            console.log( err) ;
        })
    }

  return (
    
        <>
            <div style={{overflowY:'auto' , overflowX :'hidden', height : '90%'}}>

                {

                    cards.map( (data,index) =>
                        <>
                        <DoCaseCard001 data={data} index={index} naturaleza={data.naturaleza } 
                            selected={theSelected}></DoCaseCard001>
                        </>
                        
                        
                    )


                }
                
                {/* <DoCasePlus type={'group'}></DoCasePlus> */}

            </div>

            

        </>

  )
}

export default DoCase001